/* src/app/private/configrations/email-template/email-template.component.scss */
.active_account {
  min-width: 80px;
  padding: 3px;
  background: #B3FDC0;
  text-align: center;
  text-transform: capitalize;
  color: #525252;
  font-size: 14px;
  font-weight: 600;
  padding: 5px 18px;
  border-radius: 20px;
}
.inactive_account {
  min-width: 80px;
  padding: 3px;
  background-color: #f9dcdd;
  text-align: center;
  text-transform: capitalize;
  color: #625858;
  font-size: 10px;
  font-weight: 600;
  border-radius: 5px;
  padding: 10px;
}
/*# sourceMappingURL=email-template.component.css.map */
